const routesAI = [
  // 写作
  {
    path: "/document",
    name: "document",
    redirect: "/document/index",
    component: () => import("@/views/document/index.vue"),
    meta: {
      title: "route.writing",
      crumbs: "route.writing",
      isLogin: true,
    },
    children: [
      {
        path: "/document/index",
        name: "docIndex",
        component: () => import("@/views/document/docList.vue"),
        meta: {
          title: "route.writing",
          crumbs: "route.inspiration-writing",
          isLogin: true,
        },
      },
      {
        path: "/document/templates",
        component: () => import("@/views/document/templates.vue"),
        name: "docTmpl",
        hidden: true,
        meta: {
          title: "route.writing-templates",
          crumbs: "route.writing-templates",
          isLogin: true,
          parentName: "docIndex",
          needBackBtn: true,
        },
      },
    ],
  },
  // 对话
  {
    path: "/chat",
    name: "chat",
    component: () => import("@/views/chat/index.vue"),
    meta: {
      title: "route.chat",
      crumbs: "route.chat",
      isLogin: true,
    },
  },
  // 行业顾问
  {
    path: "/adviser",
    name: "adviser",
    redirect: "/adviser/index",
    component: () => import("@/views/adviser/index.vue"),
    meta: {
      title: "route.adviser",
      crumbs: "route.adviser",
      isLogin: true,
    },
    children: [
      {
        path: "/adviser/index",
        name: "adviserIndex",
        component: () => import("@/views/adviser/list.vue"),
        meta: {
          title: "route.adviser",
          crumbs: "route.adviser",
          isLogin: true,
        },
      },
      {
        path: "/adviser/use",
        component: () => import("@/views/adviser/use.vue"),
        name: "adviserUser",
        meta: {
          title: "route.adviser",
          crumbs: "route.adviser",
          isLogin: true,
        },
      },
    ],
  },
  // ============ 媒体管理 👇 ============
  {
    path: "/platform",
    name: "platformManage",
    component: () => import("@/views/platform/index.vue"),
    meta: {
      title: "route.media-management",
      crumbs: "route.social-account-crumb",
      isLogin: true,
      // 主侧栏直接读取 sidebar 元数据生成一级导航。
      sidebar: { label: "社交账号", labelKey: "route.social-account", icon: "Social", order: 10 },
    },
  },
  {
    path: "/whatsappTemplate",
    name: "WhatappTemplate",
    component: () => import("@/views/platform/WhatsappTemplate.vue"),
    meta: {
      title: "route.whatsapp-template",
      crumbs: "route.whatsapp-template-crumb",
      isLogin: true,
      needBackBtn: true,
      parentName: "platformManage",
    },
  },
  {
    path: "/createWhatsappTemplate",
    name: "CreateWhatsAppTemplate",
    component: () => import("@/views/platform/CreateWhatsAppTemplate.vue"),
    meta: {
      title: "route.template-edit",
      crumbs: "route.media-management",
      isLogin: true,
      needBackBtn: true,
      parentName: "WhatappTemplate",
    },
  },
  {
    path: "/shopifyCallback",
    name: "shopifyCallback",
    component: () => import("@/views/platform/ShopifyAuthResult.vue"),
    meta: {
      title: "route.shopify-auth",
      crumbs: "route.shopify-auth",
      isLogin: true,
    },
  },
  {
    path: "/shoplineCallback",
    name: "shoplineCallback",
    component: () => import("@/views/platform/ShoplineAuthResult.vue"),
    meta: {
      title: "route.shopline-auth",
      crumbs: "route.shopline-auth",
      isLogin: true,
    },
  },
  {
    path: "/ctwa_auth_callback",
    name: "ctwa_auth_callback",
    component: () => import("@/views/platform/AdAccountAuthCallback.vue"),
    meta: {
      title: "route.CTWA-Auth-Callback",
      isLogin: true,
    }
  },
  {
    path: "/shopManagement",
    name: "ShopManagement",
    component: () => import("@/views/platform/shopManagement/ShopManagement.vue"),
    meta: {
      isLogin: true,
    },
    children: [
      {
        path: "/shopManagement/orderAndProduct",
        component: () => import("@/views/platform/shopManagement/OrderAndProduct.vue"),
        meta: {
          title: "route.order-product",
          crumbs: "route.ecommerce-crumb",
          isLogin: true,
          needBackBtn: true,
        },
      },
    ],
  },
  {
    path:"/whatsapp-api",
    name:"WhatsAppApiManage",
    component:()=>import("@/views/platform/WhatsAppApiManage.vue"),
    meta:{
      isLogin: true,
      title:"route.whatsapp-api",
      crumbs:"route.whatsapp-api-crumb",
    }
  },
  // ============ 媒体管理 👆 ============
  // AI 机器人先使用独立入口，避免与消息中心现有机器人路由同时高亮。
  {
    path: "/ai-robot",
    name: "aiRobot",
    component: () => import("@/views/aiRobot/index.vue"),
    meta: {
      title: "route.ai-robot",
      crumbs: "route.ai-robot",
      isLogin: true,
      // 一级菜单位于消息中心和社交聆听之间，使用独立机器人图标；仅超管与管理员可见。
      roles: [1, 2],
      sidebar: { label: "AI 机器人", labelKey: "route.ai-robot", icon: "ai-robot-menu", order: 55 },
    },
    // 设置机器人有独立 URL；列表作为父页面保留本地模拟数据与筛选状态。
    children: [
      {
        path: "settings/:robotId",
        name: "aiRobotSettings",
        component: () => import("@/views/aiRobot/RobotSettingsRoute.vue"),
        meta: {
          title: "route.ai-robot",
          crumbs: "route.ai-robot",
          isLogin: true,
          parentName: "aiRobot",
        },
      },
    ],
  },
  // 知识库
  {
    path: "/library",
    name: "libraryManage",
    redirect: "/library/list",
    component: () => import("@/views/library/index.vue"),
    meta: {
      title: "route.library",
      crumbs: "route.library-crumb",
      isLogin: true,
      // 主侧栏直接读取 sidebar 元数据生成一级导航。
      sidebar: { label: "知识库", labelKey: "route.library", icon: "Bachelor-cap", order: 80 },
    },
    children: [
      {
        path: "/library/list",
        component: () => import("@/views/library/list.vue"),
        name: "libraryList",
        meta: {
          title: "route.library",
          crumbs: "route.library-crumb",
          isLogin: true,
        },
      },
      {
        path: "/library/store",
        component: () => import("@/views/library/store.vue"),
        name: "libraryStore",
        meta: {
          title: "route.library",
          crumbs: "route.library-store-crumb",
          isLogin: true,
          parentName: "libraryList",
          needBackBtn: true,
        },
      },
      {
        path: "/library/grab",
        component: () => import("@/views/library/grab.vue"),
        name: "libraryGrab",
        meta: {
          title: "route.library-grab",
          crumbs: "route.library-grab-crumb",
          isLogin: true,
          parentName: "libraryList",
          needBackBtn: true,
        },
      },
    ],
  },
  // 模板中心
  {
    path: "/instruct",
    name: "instructManage",
    redirect: "/instruct/list",
    component: () => import("@/views/instruct/index.vue"),
    meta: {
      title: "route.instruct-center",
      crumbs: "route.instruct-center",
      isLogin: true,
    },
    children: [
      {
        path: "/instruct/list",
        component: () => import("@/views/instruct/list.vue"),
        name: "instructList",
        meta: {
          title: "route.instruct-center",
          crumbs: "route.instruct-center-crumb",
          isLogin: true,
        },
      },
      {
        path: "/instruct/store",
        name: "instructStore",
        component: () => import("@/views/instruct/store.vue"),
        meta: {
          title: "route.instruct-create",
          crumbs: "route.instruct-create-crumb",
          isLogin: true,
          parentName: "instructList",
          needBackBtn: true,
        },
      },
    ],
  },
  // 客服机器人
  {
    path: "/bot",
    name: "botManage",
    redirect: "/bot/list",
    component: () => import("@/views/bot/navigationBot.vue"),
    // component: () => import("@/views/bot/index.vue"),
    meta: {
      title: "route.bot",
      crumbs: "route.bot",
      isLogin: true,
      // 主侧栏直接读取 sidebar 元数据生成一级导航。
      sidebar: { label: "消息中心", labelKey: "route.message-center", icon: "News", order: 50 },
    },
    children: [
      {
        path: "/bot/list",
        name: "botList",
        component: () => import("@/views/bot/list.vue"),
        meta: {
          title: "route.config-bot",
          crumbs: "route.config-bot-crumb",
          isLogin: true,
          sidebar: {
            label: "配置机器人",
            labelKey: "route.config-bot",
            icon: "Robot Setting",
            order: 10,
            activePaths: ["/bot/list", "/bot/create", "/bot/store", "/bot/chat/detail", "/bot/posts/detail", "/bot/mail/detail"],
          },
        },
      },
      {
        path: "/bot/workbench",
        name: "botWorkbench",
        component: () => import("@/views/bot/workbench.vue"),
        meta: {
          title: "route.workbench",
          crumbs: "route.service-bot-crumb",
          isLogin: true,
          sidebar: {
            label: "客服机器人",
            labelKey: "route.service-bot",
            icon: "Robot",
            order: 20,
            activePaths: ["/bot/workbench", "/bot/posts/content_comment", "/bot/statistics/single"],
          },
        },
      },
      // WhatsApp 客服使用独立目录承载页面，避免将多渠道工作台误作为专属页面。
      {
        path: "/bot/whatsapp-service",
        name: "botWhatsAppService",
        component: () => import("@/views/bot/whatsappService/index.vue"),
        meta: {
          title: "route.whatsapp-service",
          crumbs: "route.whatsapp-service-crumb",
          isLogin: true,
          sidebar: {
            label: "WhatsApp 客服",
            labelKey: "route.whatsapp-service",
            icon: "WhatsApp",
            order: 30,
          },
        },
      },
      {
        path: "/bot/posts/content_comment",
        name: "ContentComment",
        component: () => import("@/views/bot/fbPosts/ContentComment.vue"),
        meta: {
          title: "route.post-detail",
          crumbs: "route.post-detail-crumb",
          isLogin: true,
          parentName: "botWorkbench",
          needBackBtn: true,
        },
      },
      // {
      //   path: "/bot/statistics",
      //   name: "botStatistics",
      //   component: () => import("@/views/bot/statistics.vue"),
      //   meta: {
      //     title: "工作台",
      //     crumbs: "JoinMC - 机器人数据统计",
      //     isLogin: true,
      //   },
      // },
      {
        path: "/bot/statistics/single",
        name: "botSingleStatistics",
        component: () => import("@/views/bot/botStatistics.vue"),
        meta: {
          title: "route.workbench",
          crumbs: "route.bot-statistics-crumb",
          isLogin: true,
          needBackBtn: true,
          parentName: "botStatistics",
        },
      },
      {
        path: "/bot/create",
        name: "botCreate",
        component: () => import("@/views/bot/botCreateComp.vue"),
        meta: {
          title: "route.bot-create",
          crumbs: "route.bot-create-crumb",
          isLogin: true,
          needBackBtn: true,
          showBotDropdown: false,
        },
      },
      {
        path: "/bot/store",
        name: "botStore",
        component: () => import("@/views/bot/commonStore.vue"),
        meta: {
          title: "route.bot-store",
          crumbs: "route.bot-store-crumb",
          isLogin: true,
          needBackBtn: false,
          showBotDropdown: true,
          parentName: "botList",
          relatedPage: {
            title: "route.view",
          },
        },
      },
      {
        path: "/bot/chat/detail",
        name: "botMessengerDetail",
        component: () => import("@/views/bot/chatRoom/detail.vue"),
        meta: {
          title: "route.messenger",
          crumbs: "route.messenger-crumb",
          isLogin: true,
          needBackBtn: false,
          showBotDropdown: true,
          parentName: "botList",
          relatedPage: {
            name: "botMessengerStore",
            title: "route.view-settings",
          },
        },
      },
      {
        path: "/bot/posts/detail",
        component: () => import("@/views/bot/fbPosts/detail.vue"),
        name: "botFbPostsDetail",
        meta: {
          title: "route.fb-posts",
          crumbs: "route.fb-posts-crumb",
          isLogin: true,
          needBackBtn: false,
          showBotDropdown: true,
          parentName: "botList",
          relatedPage: {
            name: "botFbPostsStore",
            title: "route.view-settings",
          },
        },
      },
      {
        path: "/bot/mail/detail",
        component: () => import("@/views/bot/mailManage/detail.vue"),
        name: "botMailDetail",
        meta: {
          title: "route.mail",
          crumbs: "route.mail-crumb",
          isLogin: true,
          parentName: "botList",
          needBackBtn: false,
          showBotDropdown: true,
          relatedPage: {
            name: "botMailStore",
            title: "route.view-settings",
          },
        },
      },
      {
        path: "/bot/posts/specificStore",
        name: "postSpecificStore",
        component: () => import("@/views/bot/fbPosts/specificReply/store.vue"),
        meta: {
          title: "route.specific-store",
          crumbs: "route.specific-store-crumb",
          isLogin: true,
          parentName: "botStore",
          needBackBtn: true,
        },
      },
      {
        path: "/bot/email/scene/store",
        name: "botEmailSceneStore",
        component: () => import("@/views/bot/comSceneSetting/emailSceneStore.vue"),
        meta: {
          title: "route.scene-store",
          crumbs: "route.scene-store-crumb",
          isLogin: true,
          parentName: "botStore",
          needBackBtn: true,
        },
      },
      {
        path: "/bot/scene/store",
        name: "botSceneStore",
        component: () => import("@/views/bot/comSceneSetting/sceneStore.vue"),
        meta: {
          title: "route.scene-store",
          crumbs: "route.scene-store-crumb",
          isLogin: true,
          parentName: "botStore",
          needBackBtn: true,
        },
      },
    ],
  },
  // {
  //   path: "/marketingTools",
  //   name: "MarketingTools",
  //   component: () => import("@/views/marketing/MarketingTools.vue"),
  //   meta: {
  //     title: "营销工具",
  //     isLogin: true,
  //     crumbs: "营销工具",
  //   },
  // },
  // {
  //   path: "/newTask/:taskType/:id?",
  //   name: "NewTask",
  //   component: () => import("@/views/marketing/NewTask.vue"),
  //   meta: {
  //     title: "新建群发任务模板",
  //     isLogin: true,
  //     crumbs: "群发任务模板",
  //     needBackBtn: true,
  //     parentName: "MarketingTools",
  //   },
  // },
  {
    path: "/groupTaskData/:id/:name",
    name: "GroupTaskData",
    component: () => import("@/views/marketing/GroupTaskData.vue"),
    meta: {
      title: "route.task-data",
      isLogin: true,
      crumbs: "route.task-data",
      needBackBtn: true,
      parentName: "MarketingTools",
    },
  },
  {
    path: "/groupTaskDataNew/:id/:name",
    name: "GroupTaskData",
    component: () => import("@/views/marketing/GroupTaskDataNew.vue"),
    meta: {
      title: "任务数据",
      isLogin: true,
      crumbs: "任务数据",
      needBackBtn: true,
      parentName: "MarketingTools",
    },
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/user/UserManagement.vue"),
    meta: {
      title: "route.user",
      isLogin: true,
      crumbs: "route.user",
    },
  },
];

export default routesAI;
